const LineOrientation = {
  Vertical: 'Vertical',
  Horizontal: 'Horizontal'
};

export default LineOrientation;